import React from 'react';
import styles from './overlay.scss';

const Overlay = () => {
  return (
    <div className={styles.overlay} />
  );
};
export default Overlay;
